// extracted by mini-css-extract-plugin
module.exports = {"primary":"PrimaryButton--primary--1j-b_"};